import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import enUS from 'antd/locale/en_US';
import { BrowserRouter } from 'react-router-dom';
import { buildThemeConfig, createI18n, useUiStore, installAutocompleteOff } from '@vmt/shared';
import { authResources } from '@zero/auth-admin-ui';
import { AppShell } from './App.jsx';
import vi from './i18n/vi.json';
import en from './i18n/en.json';

createI18n({ moduleVi: vi, moduleEn: en, authResources });

// Quy tắc cross-module VMT: tắt autocomplete cho mọi ô nhập text toàn site.
installAutocompleteOff();

function Root() {
  const themeMode = useUiStore((s) => s.themeMode);
  const locale = useUiStore((s) => s.locale);
  return (
    <ConfigProvider
      locale={locale === 'vi' ? viVN : enUS}
      theme={buildThemeConfig(themeMode)}
    >
      <BrowserRouter basename="/vmt">
        <AppShell />
      </BrowserRouter>
    </ConfigProvider>
  );
}

// KHÔNG wrap <React.StrictMode>: double-mount + token rotation của Zero AuthSystem v3
// làm F5 văng về login (luật cứng VmtManagement CLAUDE.md).
ReactDOM.createRoot(document.getElementById('root')).render(<Root />);
